import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import JobTraits from "components/menu/master-files/job-traits/list";

const JobTraitsRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={JobTraits}
            />
        </Switch>
    </div>
);

export default connect()(JobTraitsRouter);
